import React, { Component } from 'react'
import Styled from 'styled-components'
import { rgba, readableColor, transparentize } from 'polished'
import { SketchPicker } from 'react-color'

import Icon from 'components/Icon'
import CatchGlobalClick from 'components/CatchGlobalClick'

import dicePNG from './dice.png'

const Container = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Preview = Styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${props => props.theme.radius};
  cursor: pointer;
  // box-shadow: 0 0.25rem 0.5rem rgba(51, 51, 51, 0.05);

  &:hover {
    i {
      opacity: 0.5;
    }
  }
`

const PreviewCanvas = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: ${props => props.theme.radius};
  background-image: url(${dicePNG});
`

const PreviewColor = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: ${props => props.theme.radius};
  background-color: ${props => props.background};
  border: 1px solid ${props => transparentize(0.95, props.foreground)};
`

const PreviewIcon = Styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${props => props.foreground};
  opacity: 0.25;
  font-size: 1.5rem;
  transition: 300ms;

`

const Picker = Styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  z-index: 1;
  font-family: ${props => props.theme.fonts.regular};

  ${props => props.align === 'left' && `
    left: 0;
  `}

  ${props => props.align === 'right' && `
    right: 0;
  `} 

  ${props => (props.align === 'center' || !props.align) && `
    left: 50%;
    transform: translateX(-50%);
  `}
`

class ColorBox extends Component {
  state = {
    isPickerOpen: false
  }

  handleOpenPicker = () => {
    this.setState({ isPickerOpen: true })
  }

  handleClosePicker = () => {
    this.setState({ isPickerOpen: false })
  }

  render() {
    const cssValue = rgba(this.props.value.r, this.props.value.g, this.props.value.b, this.props.value.a)

    return (
      <Container>
        <Preview onClick={this.handleOpenPicker}>
          <PreviewCanvas />

          <PreviewColor
            background={cssValue}
            foreground={readableColor(cssValue)}
          />

          <PreviewIcon
            liga="colorize"
            foreground={readableColor(cssValue)}
          />
        </Preview>

        {this.state.isPickerOpen &&
          <CatchGlobalClick onClick={this.handleClosePicker}>
            <Picker align={this.props.align}>
              <SketchPicker
                color={this.props.value}
                onChangeComplete={color => this.props.onChange(color.rgb)}
              />
            </Picker>
          </CatchGlobalClick>
        }
      </Container>
    )
  }
}

export default ColorBox



// WEBPACK FOOTER //
// ./src/editor/ColorBox/index.js